export default {
  'memberAreaCouponHistory.title': 'ประวัติการใช้คูปอง',
  'memberAreaCouponHistory.time': 'เวลา',
  'memberAreaCouponHistory.serial_number': 'หมายเลขคูปอง',
  'memberAreaCouponHistory.redeem_store': 'ร้านค้าที่ใช้คูปอง',
  'memberAreaCouponHistory.redeem_no': 'รหัสการใช้คูปอง',
} as Record<string, string>;
